import useApi, { Model, Query } from "../../common/hooks/useApi";
import { Equipo } from "../../equipos/useEquiposAPI";
import { TitularVehiculo } from "../../titulares-vehiculo/useTitularesVehiculoAPI";

export interface InfraccionJuzgado extends Model {
    Id: number
    Titular: TitularVehiculo
    TitularId: number
    Equipo: Equipo
    EquipoId: number
    Estado: string
    EstadoPago: ("IMPAGA" | "PAGADA")
    Patente: string
    FechaHora: string
    FechaVencimiento: string
    Fecha2doVencimiento: string
    FechaVencimientoCallCenter: string
}

export interface InfraccionJuzgadoImpaga extends Model {
    NroActa: number    
    FechaCreacion: string
    Dominio: string
    NombreInfractor: string
    CuilCuitInfractor: string
    DireccionInfractor: string
    DniInfractor: string    
}

const useJuzgadoInfraccionApi = () => {
    const module = "JuzgadoInfraccion";
    const api = useApi({ module });    
    return {
        list: (query: Query) => api.list!<InfraccionJuzgado>(query),
        save: (data: Partial<InfraccionJuzgado>) => api.save!<Partial<InfraccionJuzgado>, InfraccionJuzgado>(data),
        delete: (id: number) => api.delete!<InfraccionJuzgado>(id)
    }
};

export default useJuzgadoInfraccionApi;